//#region src/polyfills.ts
if (typeof globalThis === "undefined") window.globalThis = window;
if (typeof queueMicrotask === "undefined") globalThis.queueMicrotask = (cb) => Promise.resolve().then(cb).catch((e) => setTimeout(() => {
	throw e;
}));
if (!Object.fromEntries) Object.fromEntries = function fromEntries(entries) {
	const obj = {};
	for (const [k, v] of entries) obj[String(k)] = v;
	return obj;
};
if (!Promise.allSettled) Promise.allSettled = ((promises) => Promise.all(Array.from(promises, (p) => Promise.resolve(p).then((value) => ({
	status: "fulfilled",
	value
}), (reason) => ({
	status: "rejected",
	reason
})))));
for (const { prototype } of [Element, DocumentFragment]) if (!prototype.replaceChildren) prototype.replaceChildren = function replaceChildren(...nodes) {
	while (this.lastChild) this.removeChild(this.lastChild);
	if (nodes.length > 0) this.append(...nodes);
};
if (!Array.prototype.at) Array.prototype.at = function at(n) {
	const i = Math.trunc(n) || 0;
	const idx = i < 0 ? i + this.length : i;
	return idx < 0 || idx >= this.length ? void 0 : this[idx];
};
if (!Object.hasOwn) Object.hasOwn = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
if (typeof structuredClone === "undefined") globalThis.structuredClone = (val) => JSON.parse(JSON.stringify(val));
if (typeof AbortSignal !== "undefined" && !AbortSignal.prototype.throwIfAborted) AbortSignal.prototype.throwIfAborted = function throwIfAborted() {
	if (this.aborted) throw this.reason ?? new DOMException("signal is aborted without reason", "AbortError");
};
//#endregion
export {};

//# sourceMappingURL=polyfills.js.map